// Převod identifikátorů — jádro stabilního veřejného kontraktu (§7, §35/#1).
// Veřejným identifikátorem objektu je IfcRoot.GlobalId; interně se pracuje s
// (modelId + expressID). FragmentsGroup poskytuje nativní mapu globalToExpressIDs,
// z níž odvodíme i zpětný převod. Hostitel nikdy nevidí expressID jako jediný klíč.

// Sestaví obousměrný index pro jeden model.
export function buildIdIndex(group) {
  const globalToExpress = group.globalToExpressIDs instanceof Map ? group.globalToExpressIDs : new Map();
  const expressToGlobal = new Map();
  for (const [gid, eid] of globalToExpress) expressToGlobal.set(eid, gid);
  return { globalToExpress, expressToGlobal };
}

// GlobalId musí být neprázdný řetězec (IFC GUID, 22 znaků). Neověřujeme přesný
// formát, jen základní tvar — chybný tvar hlásí INVALID_GLOBAL_ID.
export function isValidGlobalId(gid) {
  return typeof gid === "string" && gid.length > 0;
}

// expressID → GlobalId pro daný model (nebo null).
export function expressToGlobalId(model, expressID) {
  return model.ids.expressToGlobal.get(expressID) || null;
}

// GlobalId → expressID pro daný model (nebo null).
export function globalIdToExpress(model, globalId) {
  const eid = model.ids.globalToExpress.get(globalId);
  return eid == null ? null : eid;
}

// Sloučí (model, [expressID]) do FragmentIdMap { [fragID]: Set<expressID> },
// který přijímají Highlighter i Hider. Model musí patřit stejnému jádru.
export function fragmentMapForExpress(model, expressIDs) {
  const ids = Array.isArray(expressIDs) ? expressIDs : [expressIDs];
  try { return model.group.getFragmentMap(ids); } catch (_) { return {}; }
}

// Spojí dvě FragmentIdMap do jedné (pro operace nad více modely v jednom volání
// Highlighteru/Hideru je nutné volat per-model — tento merge slouží uvnitř modelu).
export function mergeFragmentMaps(a, b) {
  const out = { ...a };
  for (const k in b) {
    if (out[k]) for (const v of b[k]) out[k].add(v);
    else out[k] = new Set(b[k]);
  }
  return out;
}
